export const CRUD_PATH = `streetPart`

export const CRUD_PATH_PLURAL = `streetParts`
